import { Check } from 'lucide-react'
import { toast } from 'sonner'
import { useCompleteCancellationAction } from '@/api/hooks'
import { LoadingButton } from '@/components/loading-button'

export function CancellationActionComplete({ projectUuid }: { projectUuid: string }) {
  const complete = useCompleteCancellationAction(projectUuid)
  return (
    <LoadingButton
      variant="outline"
      size="sm"
      loading={complete.isPending}
      loadingText="Completing..."
      onClick={() =>
        complete.mutate(undefined, {
          onError: () => toast.error('Could not complete the credit follow-up. Try again.'),
        })
      }
    >
      <Check /> Mark complete
    </LoadingButton>
  )
}
